import React from 'react';

export default function CardFiles(props) {

    const { preview, title, email, megaLink, driveLink, megaLogo, driveLogo, setLink ,promo} = props

    return ( 
      <div className= {promo ? 'card-files-page card-files-page-promo' : 'card-files-page'}>
      <img src={preview} className='image-card' width="100%" height="140" alt="Logo" />

    <h3 className='name-files-page text-center' >{title}</h3>
      <div className='d-flex'>
        <button className="button-down btn btn-outline-light my-2 my-sm-0 mr-1" data-toggle="modal" data-target={email ? "#nenhum" : "#inseriremail"}
          onClick={() => {
            if (email) {
              window.open(megaLink, '_blank')
            }
            setLink(megaLink)
          }}>
          <img className='mt-1 mb-1 mr-2' src={megaLogo} width={12} height={12} alt="Logo" />
          <span className='pt-1' >Baixar</span>
        </button>
        <button className="button-down btn btn-outline-light my-2 my-sm-0" data-toggle="modal" data-target={email ? "#nenhum" : "#inseriremail"}
          onClick={() => {
            if (email) {
              window.open(driveLink, '_blank')
            }
            setLink(driveLink)
          }}>
          <img className='mt-1 mb-1 mr-2' src={driveLogo} width={12} height={12} alt="Logo" />
          <span className='pt-1'>Baixar</span>
        </button>
      </div>
    </div>
  );
}




